<div class="main-content">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header card-header-danger">
            <h4 id="lblheader">{{lblheader}}</h4>
          </div>

          <div class="card-body">
            <form [formGroup]="CompleteReportForm">
              <div class="row">

                <div class="col-md-6">
                  <div class="row">
                    <div class="col-md-4 control-label"> <label>Date (From)</label></div>
                    <div class="col-md-7">
                      <div class="input-group ">
                        <input readonly [matDatepicker]="RequisitionFromDatePicker"
                          formControlName="RequisitionFromDate" class="form-control"
                               placeholder="Date (From)" #ref
                          ng-model-options="{timezone: 'UTC'}"
                               (dateChange)="orgValueChange(ref.value)">
                        <mat-datepicker-toggle class="input-group-addon iconWithInput" matSuffix
                          [for]="RequisitionFromDatePicker"></mat-datepicker-toggle>
                        <mat-datepicker #RequisitionFromDatePicker></mat-datepicker>

                      </div>

                    </div>
                    <div class="col-md-1"></div>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="row">
                    <div class="col-md-4 control-label"> <label>Date (To)</label></div>

                    <div class="col-md-8">
                      <div class="input-group ">
                        <input readonly [matDatepicker]="RequisitionToDatePicker" formControlName="RequisitionToDate"
                          class="form-control" placeholder="Date (To)" ng-model-options="{timezone: 'UTC'}"
                          [min]="toDate">
                        <mat-datepicker-toggle class="input-group-addon iconWithInput" matSuffix
                          [for]="RequisitionToDatePicker"></mat-datepicker-toggle>
                        <mat-datepicker #RequisitionToDatePicker></mat-datepicker>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="clearfix"></div>
                <br>
                <div class="row">
                  <div class="col-md-4">

                  </div>

                  <div class="col-md-4">
                    <button class="btn-primary1" (click)="Export()">Export as Excel</button>

                  </div>
                  <div class="col-md-4">
                  </div>

                </div>

              </div>

            </form>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>
